import { Text, ThirdPartyButton } from 'shell/components';

const ThirdPartyButtonDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>ThirdPartyButton</Text>
            <ThirdPartyButton variant={'google'} onClick={() => console.log('google')} />
        </>
    );
};

export default ThirdPartyButtonDemo;
